export default __webpack_public_path__ + "static/screeny-110-gpz-unica-am-2-2b4e76fdc128c444d424d22bef4c9c39.jpg";